import { render, staticRenderFns } from "./AssetGroupsModal.vue?vue&type=template&id=a4510c66&scoped=true"
import script from "./AssetGroupsModal.vue?vue&type=script&lang=js"
export * from "./AssetGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./AssetGroupsModal.vue?vue&type=style&index=0&id=a4510c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4510c66",
  null
  
)

export default component.exports